import { render, staticRenderFns } from "./fornecedorShow.vue?vue&type=template&id=12e16d94"
import script from "./fornecedorShow.vue?vue&type=script&lang=js"
export * from "./fornecedorShow.vue?vue&type=script&lang=js"
import style0 from "./fornecedorShow.vue?vue&type=style&index=0&id=12e16d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports